import { render, staticRenderFns } from "./CatalogPreviewEager.vue?vue&type=template&id=332fd016&scoped=true"
import script from "./CatalogPreviewEager.vue?vue&type=script&lang=js"
export * from "./CatalogPreviewEager.vue?vue&type=script&lang=js"
import style0 from "./CatalogPreviewEager.vue?vue&type=style&index=0&id=332fd016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332fd016",
  null
  
)

export default component.exports